import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import Link from 'components/consumer/Link';
import PDPMobileCarousel from 'components/consumer/PDP/PDPMobileCarousel';
import MobileModal from 'components/consumer/MobileModal';
import useIsBrowser from 'hooks/useIsBrowser';
import { GALLERY_IMAGE_LOCATION, GALLERY_INTERACTION } from 'data-hooks/useEvents/pdpGalleryEventConstants';
import PDPDimensionsContent from '../PDPDimensionsContent';
const PDPMobileStudioCampaignLogo = loadable(() => import('./PDPMobileStudioCampaignLogo'));
const PDPMobileStudioPhotoGalleryUI = t0 => {
  const $ = _c(34);
  const {
    enableCrops: t1,
    introVideoId,
    linkTo,
    mode: t2,
    photos: t3,
    productName,
    resetGalleryImageTracking,
    trackGalleryInteracted,
    viewGalleryImageEvent,
    campaign
  } = t0;
  const enableCrops = t1 === undefined ? true : t1;
  const mode = t2 === undefined ? "pdp" : t2;
  let t4;
  if ($[0] !== t3) {
    t4 = t3 === undefined ? [] : t3;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const photos = t4;
  const isPdpMode = mode === "pdp";
  const isGalleryLinked = !isPdpMode && linkTo;
  const GalleryWrapper = isGalleryLinked ? Link : "div";
  const [isDimensionsModalOpen, setIsDimensionsModalOpen] = useState(false);
  const isBrowser = useIsBrowser();
  let t5;
  if ($[2] !== photos || $[3] !== viewGalleryImageEvent) {
    t5 = photo => {
      if (!photo?.src) {
        return;
      }
      const position = photos.findIndex(t6 => {
        const {
          src
        } = t6;
        return src === photo.src;
      });
      if (position === -1) {
        return;
      }
      viewGalleryImageEvent?.({
        imageLocation: GALLERY_IMAGE_LOCATION.LIFESTYLE,
        imageFilename: photo.src.split("/").pop() || "",
        totalImages: photos.length,
        position
      });
    };
    $[2] = photos;
    $[3] = viewGalleryImageEvent;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const reportPhotoViewed = t5;
  let t6;
  if ($[5] !== isGalleryLinked) {
    t6 = classNames("PDPMobileStudioPhotoGalleryUI", {
      "block mt-[5px]": isGalleryLinked
    });
    $[5] = isGalleryLinked;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = isGalleryLinked ? linkTo : null;
  let t8;
  if ($[7] !== campaign || $[8] !== isBrowser) {
    t8 = isBrowser ? <PDPMobileStudioCampaignLogo campaign={campaign} /> : null;
    $[7] = campaign;
    $[8] = isBrowser;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== resetGalleryImageTracking || $[11] !== trackGalleryInteracted) {
    t9 = () => {
      resetGalleryImageTracking?.();
      trackGalleryInteracted?.(GALLERY_INTERACTION.LIFESTYLE_GALLERY_OPENED);
    };
    $[10] = resetGalleryImageTracking;
    $[11] = trackGalleryInteracted;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== enableCrops || $[14] !== introVideoId || $[15] !== isPdpMode || $[16] !== photos || $[17] !== productName || $[18] !== reportPhotoViewed || $[19] !== t9) {
    t10 = <PDPMobileCarousel enableCrops={enableCrops} isHero={true} photos={photos} videoId={introVideoId} productName={productName} showFavoriteButton={isPdpMode} onAfterSlide={reportPhotoViewed} onOpenFullScreenGallery={t9} onPhotoViewed={reportPhotoViewed} displayShownIn={isPdpMode} showARIcon={true} zoomOnClick={isPdpMode} />;
    $[13] = enableCrops;
    $[14] = introVideoId;
    $[15] = isPdpMode;
    $[16] = photos;
    $[17] = productName;
    $[18] = reportPhotoViewed;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== GalleryWrapper || $[22] !== t10 || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
    t11 = <GalleryWrapper className={t6} to={t7}>{t8}{t10}</GalleryWrapper>;
    $[21] = GalleryWrapper;
    $[22] = t10;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  let t13;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = () => {
      setIsDimensionsModalOpen(false);
    };
    t13 = <PDPDimensionsContent />;
    $[27] = t12;
    $[28] = t13;
  } else {
    t12 = $[27];
    t13 = $[28];
  }
  let t14;
  if ($[29] !== isDimensionsModalOpen) {
    t14 = <MobileModal isOpen={isDimensionsModalOpen} title="Dimensions" isFullHeight={true} onClose={t12}>{t13}</MobileModal>;
    $[29] = isDimensionsModalOpen;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t11 || $[32] !== t14) {
    t15 = <>{t11}{t14}</>;
    $[31] = t11;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  return t15;
};
PDPMobileStudioPhotoGalleryUI.propTypes = {
  enableCrops: PropTypes.bool,
  introVideoId: PropTypes.string,
  linkTo: PropTypes.string,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  photos: PropTypes.arrayOf(PropTypes.object),
  productName: PropTypes.string,
  resetGalleryImageTracking: PropTypes.func,
  trackGalleryInteracted: PropTypes.func,
  viewGalleryImageEvent: PropTypes.func,
  campaign: PropTypes.string
};
export default PDPMobileStudioPhotoGalleryUI;